export default function formatDrillDownCategory(category) {
  if (category && category.columns) {
    return {
      ...category,
      links: category.columns,
    }
  }
  return category
}
